import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    // Log to console for development
    console.error('🔥 Global error caught:', error);

    // Send to Sentry if initialized
    try {
      Sentry.captureException(error);
    } catch (sentryError) {
      // Sentry not initialized or error sending to Sentry
      console.warn('[Sentry] Failed to capture exception:', sentryError);
    }
  }
}
